import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import OtpSingleInput from './OtpSingleInput';


function OtpInput(props) {
    const { numberOfInputs, timeInterval, displayCountdown, onCountdownFinish, countdownText, onOtpEnter } = props;
    //const [isComplete, setIsComplete] = useState(false);
    const [focusIndex, setFocusIndex] = useState(0);
    const [otpValueArray, setOtpValueArray] = useState(new Array(numberOfInputs));
    const [seconds, setSeconds] = useState(timeInterval);
    const [isCountdownActive, setIsCountdownActive] = useState(displayCountdown);


    useEffect(() => {
        let interval = null;
        if (isCountdownActive && seconds !== 0) {
            interval = setInterval(() => {
                setSeconds(seconds => seconds - 1);
            }, 1000);
        } else {
            if (isCountdownActive && seconds === 0) {
                setIsCountdownActive(false);
                onCountdownFinish();
            }
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [isCountdownActive, seconds]);

    useEffect(()=>{
        if (displayCountdown && seconds === 0 ){
            setIsCountdownActive(true);
            setSeconds(timeInterval);
        }
    }, [displayCountdown])

    useEffect(() => {
        let tempOtpValArr = [...otpValueArray];

        let completed = true;
        for (let i = 0; i < numberOfInputs; i++) {
            if (!tempOtpValArr[i] || tempOtpValArr[i] === "") {
                completed = false;
                break;
            }
        }
        if (completed) {
            let otp = otpValueArray.join('');
            console.log("otp=", otp);
            onOtpEnter(otp);
            //setIsComplete(true);
            setIsCountdownActive(false);
        }


    }, [otpValueArray]);

    const onSingleInputChange = (e, index) => {
        let tempOtpValArr = [...otpValueArray];
        tempOtpValArr[index] = e.target.value;
        setOtpValueArray(tempOtpValArr);

        if (focusIndex === numberOfInputs - 1) {
            setFocusIndex(0);
        } else {
            setFocusIndex(i => i + 1);
        }

    }

    const getInputArray = () => {
        let inputs = [];
        for (let i = 0; i < numberOfInputs; i++) {
            inputs.push(<OtpSingleInput
                key={i}
                isFocus={i === focusIndex}
                index={i}
                onInputChange={onSingleInputChange}
                value={otpValueArray[i] ? otpValueArray[i] : ""}
                onFocus={(e) => { setFocusIndex(i); e.target.select(); }}
            />);
        }
        return inputs;
    }

    return (
        <div className={'m-reg-form-inner-wrapper'}>
            {/*<div className={'verification-code-wrapper d-flex'}>*/}
            {/*    {getInputArray()}*/}
            {/*</div>*/}
            {isCountdownActive && <>
                <div className={'verification-message text-center mt-3'}>
                    {`${countdownText} ${seconds}`}
                </div>
            </>
            }
        </div>
    )
};

OtpInput.propTypes = {
    numberOfInputs: PropTypes.number.isRequired,
    onOtpEnter: PropTypes.func.isRequired,
    displayCountdown: PropTypes.bool.isRequired,
    timeInterval: PropTypes.number,
    onCountdownFinish: PropTypes.func,
    countdownText: PropTypes.string,
}

export default OtpInput

